// @flow

import { getErrorMsg } from '../../../lib/CoreValidations'
import type { ValidationResult } from '@bil0-dr-bill/dr-bill-core'

type OnChangeFn = (string) => ValidationResult

export const healthNumber: HTMLInputElement = (document.querySelector('#health_number'): any)

function resetFields(field: HTMLInputElement): void {
  if (field && field.closest('div')?.classList.contains('find-patient-error')) {
    const validationMessage = field.nextElementSibling

    field.closest('div')?.classList.remove('clearfix', 'has-error', 'find-patient-error')
    if (
      validationMessage instanceof HTMLElement &&
      validationMessage.classList.contains('help-inline')
    ) {
      validationMessage.remove()
    }
  }
}

function displayErrorField(field: HTMLInputElement, message: string): void {
  if (field) {
    const spanElement = document.createElement('span')
    spanElement.textContent = message
    spanElement.className = 'help-inline'

    const parentDiv = field.parentNode
    if (parentDiv && parentDiv instanceof HTMLElement) {
      parentDiv.classList.add('clearfix', 'has-error', 'find-patient-error')
      parentDiv.insertBefore(spanElement, field.nextElementSibling)
    }
  }
}

function healthNumberText(province: string): string {
  if (province === 'bc') {
    return 'Care Card Number'
  } else if (province === 'on' || province === 'ab') {
    return 'Health Card Number'
  } else {
    return 'Policy Number'
  }
}

function validateVersionCode(): boolean {
  const versionCode: HTMLInputElement = (document.querySelector('#insurance_version_code'): any)
  const versionCodeRegexp = new RegExp('^([A-Za-z]{1,2})$')

  resetFields(versionCode)

  if (versionCode && versionCode.value) {
    if (versionCodeRegexp.test(versionCode.value)) {
      versionCode.value = versionCode.value.toUpperCase()
      return true
    } else {
      displayErrorField(versionCode, '1 or 2 letters')
      return false
    }
  }
  return true
}

export function validateFields(province: string, onChange: OnChangeFn): boolean {
  resetFields(healthNumber)

  const healthNumberLength = province === 'ab' ? 9 : 10
  const healthCardRegexp = new RegExp(
    '^([0-9]{' + healthNumberLength + ',' + healthNumberLength + '})$'
  )

  if (!healthNumber || !healthNumber.value) {
    const message = `${healthNumberText(province)} is required`

    displayErrorField(healthNumber, message)
    validateVersionCode()
    return false
  }

  if (province === 'bc') {
    const validateBcPhn = onChange(healthNumber.value)

    if (!validateBcPhn.is_success) {
      const message = `${healthNumberText(province)} ${getErrorMsg(validateBcPhn)}`

      displayErrorField(healthNumber, message)
      return false
    }
    return true
  }

  if (!healthCardRegexp.test(healthNumber.value)) {
    const message = `${healthNumberText(province)} should be ${healthNumberLength} numbers`

    displayErrorField(healthNumber, message)
    validateVersionCode()
    return false
  }

  return validateVersionCode()
}
